import React from "react";

const SearchIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="32px"
      height="32px"
      viewBox="0 0 500.000000 500.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        fill="#4abae8"
        stroke="none"
      >
        <path
          d="M2842 4974 c-192 -30 -496 -137 -662 -234 -163 -95 -388 -291 -519
         -450 -191 -234 -340 -581 -386 -904 -24 -162 -16 -478 14 -616 31 -138 76
         -277 131 -403 32 -75 45 -117 40 -127 -5 -8 -287 -292 -626 -630 -340 -338
         -646 -648 -680 -689 -105 -124 -143 -221 -144 -366 0 -146 47 -267 146 -373
         95 -102 187 -150 333 -173 126 -19 275 23 393 112 29 21 348 334 709 695 l656
         656 39 -17 c338 -147 539 -194 829 -195 231 0 383 23 585 90 303 100 507 223
         724 437 139 138 188 195 268 317 133 202 244 498 284 755 22 140 22 392 0 531
         -42 273 -151 557 -299 778 -71 107 -262 316 -377 413 -224 189 -583 345 -905
         394 -127 19 -426 18 -553 -1z m619 -317 c236 -56 408 -139 652 -314 55 -39
         243 -236 263 -274 9 -18 36 -60 61 -93 101 -138 209 -414 237 -607 22 -150 21
         -370 -4 -511 -34 -200 -133 -448 -233 -584 -25 -33 -52 -75 -61 -93 -20 -38
         -208 -234 -263 -274 -21 -15 -65 -46 -98 -68 -33 -21 -78 -51 -100 -66 -97
         -65 -314 -150 -470 -184 -133 -30 -414 -37 -560 -15 -200 31 -473 138 -611
         239 -33 25 -76 53 -95 62 -44 23 -281 260 -304 304 -9 19 -37 62 -62 95 -88
         121 -190 365 -229 551 -27 129 -27 471 0 600 39 186 139 427 229 551 25 33 53
         76 62 95 25 48 261 282 310 307 22 11 65 39 95 62 70 53 226 129 355 173 85
         29 145 43 305 71 14 3 113 3 220 1 165 -3 211 -7 301 -28z m-1831 -2657 c0
         -15 274 -293 331 -337 27 -20 49 -40 49 -43 0 -3 -290 -296 -645 -650 -701
         -702 -699 -699 -806 -700 -84 0 -146 25 -205 84 -59 59 -84 121 -84 205 0 108
         -3 105 700 807 354 354 648 644 652 644 4 0 8 -4 8 -10z"
        />
        <path
          d="M3070 4213 c-202 -11 -394 -78 -563 -197 -33 -22 -74 -51 -91 -62
         -80 -54 -185 -196 -266 -359 -67 -133 -94 -227 -109 -371 -13 -127 4 -167 70
         -167 54 0 71 29 80 138 36 426 317 753 726 846 27 5 90 14 141 18 106 9 135
         27 135 80 0 57 -35 78 -123 74z"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
